import { render } from "./first.vue?vue&type=template&id=4a421efb&scoped=true"
import script from "./first.vue?vue&type=script&lang=js"
export * from "./first.vue?vue&type=script&lang=js"

import "./first.vue?vue&type=style&index=0&id=4a421efb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a421efb"

export default script